import { render, staticRenderFns } from "./FormBoxRadio.vue?vue&type=template&id=03298a72&scoped=true"
import script from "./FormBoxRadio.vue?vue&type=script&lang=js"
export * from "./FormBoxRadio.vue?vue&type=script&lang=js"
import style0 from "./FormBoxRadio.vue?vue&type=style&index=0&id=03298a72&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03298a72",
  null
  
)

export default component.exports